// Global
import { withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { useTheme } from 'lib/context/ThemeContext';
import { getEnum } from 'lib/utils/get-enum';
import useExperienceEditor from 'lib/utils/use-experience-editor';
import { Feature } from 'src/.generated/Feature.EnterpriseWeb.model';

// Components
import { BodyCopy } from 'src/helpers/BodyCopy';
import ButtonGroup from 'src/helpers/ButtonGroup/ButtonGroup';
import Component from 'src/helpers/Component/Component';
import Headline from 'src/helpers/Headline/Headline';
import { PromoFlipsnackViewerTheme } from './PromoFlipsnackViewer.theme';
import { cta1ToButtonProps, cta2ToButtonProps } from 'src/helpers/Button';

export type ImagePosition = 'right' | 'left';

export type PromoFlipsnackViewerProps =
  Feature.EnterpriseWeb.Enterprise.Components.Promo.PromoFlipsnackViewer.PromoFlipsnackViewer;
const PromoFlipsnackViewer = (props: PromoFlipsnackViewerProps) => {
  const flipsnackLeftAlign =
    (getEnum<ImagePosition>(props?.fields?.flipsnackPlacement) ?? 'right') == 'left';
  const { themeData } = useTheme(PromoFlipsnackViewerTheme(flipsnackLeftAlign));

  const baseUrl =
    props?.fields?.flipsnackBaseSrc?.value?.length > 0
      ? props?.fields?.flipsnackBaseSrc?.value
      : `https://cdn.flipsnack.com/widget/v2/widget.html`;
  const srcUrl =
    baseUrl +
    (baseUrl.indexOf('?') >= 0 ? '&' : '?') +
    `hash=${props?.fields?.flipsnackId?.value}&t=${props?.fields?.flipsnackVersion?.value}`;
  const isEE = useExperienceEditor();

  const iframeTitle = !!props?.fields?.iframeTitle?.value
    ? props?.fields?.iframeTitle?.value
    : props?.fields?.headlineText?.value;

  return (
    <Component variant="lg" dataComponent="promo/promoflipsnackviewer" {...props}>
      <div className={themeData.classes.iframeContainer}>
        <iframe
          className={themeData.classes.iframe}
          src={srcUrl}
          seamless={true}
          scrolling="no"
          frameBorder="0"
          allowFullScreen={true}
          loading="lazy"
          title={iframeTitle}
          height={'200px'}
        ></iframe>
      </div>
      <div className={themeData.classes.copyContainer}>
        <Headline classes={themeData.classes.headline} {...props} />
        {(isEE || props.fields?.body) && <BodyCopy classes={themeData.classes?.body} {...props} />}
        {(isEE || props.fields?.cta1Link) && (
          <ButtonGroup
            cta1={cta1ToButtonProps(props, themeData.classes.buttonGroupClasses.cta1Classes)}
            cta2={cta2ToButtonProps(props, themeData.classes.buttonGroupClasses.cta2Classes)}
            wrapperClasses={themeData.classes.buttonGroupClasses.wrapper}
          />
        )}
      </div>
    </Component>
  );
};

export default withDatasourceCheck()<PromoFlipsnackViewerProps>(PromoFlipsnackViewer);
